"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextTimeInput = exports.getInputMask = exports.MASKS = exports.TEXT_TIME_INPUT_FORMAT = void 0;
const react_1 = __importDefault(require("react"));
const react_text_mask_1 = __importDefault(require("react-text-mask"));
const react_i18next_1 = require("react-i18next");
const View_1 = require("@amzn/atoz-web/View");
const Theme_1 = require("@amzn/atoz-web/Theme");
exports.TEXT_TIME_INPUT_FORMAT = 'hh:mm a';
exports.MASKS = {
    MILITARY: {
        BASE: [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/],
        AFTER_HOUR_20: [/[0-2]/, /[0-3]/, ':', /[0-5]/, /[0-9]/],
        BEFORE_HOUR_20: [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]
    },
    NONMILITARY: {
        BASE: [/[0-1]/, /[0-9]/, ':', /[0-5]/, /[0-9]/, ' ', /[APap]/, 'm'],
        AFTER_HOUR_10: [
            /[0-1]/,
            /[0-2]/,
            ':',
            /[0-5]/,
            /[0-9]/,
            ' ',
            /[APap]/,
            'm'
        ],
        BEFORE_HOUR_10: [/[0]/, /[1-9]/, ':', /[0-5]/, /[0-9]/, ' ', /[APap]/, 'm']
    }
};
const getInputMask = (value, useMilitaryTime) => {
    if (value === '' || value === undefined) {
        return useMilitaryTime ? exports.MASKS.MILITARY.BASE : exports.MASKS.NONMILITARY.BASE;
    }
    if (useMilitaryTime) {
        return value[0] === '2'
            ? exports.MASKS.MILITARY.AFTER_HOUR_20
            : exports.MASKS.MILITARY.BEFORE_HOUR_20;
    }
    else {
        return value[0] === '1'
            ? exports.MASKS.NONMILITARY.AFTER_HOUR_10
            : exports.MASKS.NONMILITARY.BEFORE_HOUR_10;
    }
};
exports.getInputMask = getInputMask;
const TextTimeInput = ({ placeholder, dataTestId, value, onChange, militaryTime, className, disabled, hideFocusPlaceholder, ariaLabel }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const useMilitaryTime = militaryTime !== null && militaryTime !== void 0 ? militaryTime : false;
    const focusedHandler = (e) => {
        if (!hideFocusPlaceholder) {
            e.target.placeholder = useMilitaryTime
                ? t('time_and_attendance_PunchModal_TextInput_Example_24')
                : t('time_and_attendance_PunchModal_TextInput_Example');
        }
    };
    const blurredHandler = (e) => {
        e.target.placeholder = placeholder;
    };
    return (react_1.default.createElement(TextTimeInputContainer, { dataTestId: "TextTimeInput" },
        react_1.default.createElement(react_text_mask_1.default, { disabled: disabled, className: className, type: "text", mask: (0, exports.getInputMask)(value, useMilitaryTime), value: value, placeholder: placeholder, onChange: (e) => onChange(e.target.value), onFocus: (e) => focusedHandler(e), onBlur: (e) => blurredHandler(e), id: dataTestId, "data-testid": dataTestId, "aria-label": ariaLabel })));
};
exports.TextTimeInput = TextTimeInput;
const TextTimeInputContainer = (0, Theme_1.styledWithTheme)(View_1.View) `
    .form-control {
        height: 200%;
    }

    input[type='text'] {
        background-repeat: no-repeat;
        background-position: 12px center;
        height: 45px;
        width: 100%;
        padding: 6px 8px;
    }

    .error {
        border: 1px solid #cd3e3e;
    }
`;
